import React from 'react';

const Loading = (props) => {

    let loadingClassName = "fa fa-spin fa-circle-notch mr-2 ";
    loadingClassName += props.className ? props.className : '';
    
    return (
        <span style={props.style} className={props.transparent ? "text-primary font-size-13" : "font-size-13 border-rounded p-2 bg-primary-light"} >
            <i className={loadingClassName}></i>
            {props.children}
        </span>
    );
}
export default Loading;
